import { render, staticRenderFns } from "./VehiculeFormReserve.vue?vue&type=template&id=229d0488&"
import script from "./VehiculeFormReserve.vue?vue&type=script&lang=js&"
export * from "./VehiculeFormReserve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports